	// import graphics						from '@/components/info/graphics.vue'
	// import axios 						from 'axios'
	import EventBus 					from '@/event-bus';
	import VueGridLayout 				from 'vue-grid-layout';
	// import mapview from '@/components/mapview.vue'
	// components
	import blank_component 				from '@/components/dashboard/blank_component.vue'
	// import analytic_list 				from '@/components/analytics/analytics_default.json'
	import cam 							from '@/components/cam.vue'
	import cam_test 					from '@/components/cam_test.vue'
	import events 						from '@/components/events/events.vue'
	//  Objects / Motion
	import zone							from '@/components/zones/zones.vue'
	// import timeline 					from '@/components/events/timeline.vue'
	// multicomponents
	import counter						from '@/components/analytics/counter.vue'
	//Face
	import detected_faces 				from '@/components/face/detected_face.vue'
	import recognized 					from '@/components/face/recognized_face.vue'
	// mapview
	import mapview  					from '@/components/mapview.vue'
	import workspace  					from '@/components/workspace/workspaces.vue'
	import register_events_parking		from "@/components/parking/parking.vue"
	import statistics_parking 			from "@/components/parking/statistics.vue"
	import Iframe 						from "@/components/Iframe.vue"
	import alarm_stats_widget 			from "@/components/alarms/stats/AlarmStatsWidget.vue"
	import DashboardPieEventsConfigDialog from "@/components/dashboard/DashboardPieEventsConfigDialog.vue"
	import dashboard_pie_events_widget from "@/components/dashboard/DashboardPieEventsWidget.vue"
	import dashboard_kpi_events_widget from "@/components/dashboard/DashboardKpiEventsWidget.vue"
	import dashboard_alerts_by_device_heatmap_widget from "@/components/dashboard/DashboardAlertsByDeviceHeatmapWidget.vue"
	import dashboard_operator_action_time_widget from "@/components/dashboard/DashboardOperatorActionTimeWidget.vue"
	import cloud_queue_widget from "@/components/dashboard/CloudQueueWidget.vue"
	import access_control_multi_face_roster from "@/components/access-control/access_control_multi_face_roster.vue"
	import { buildPieEventsStreamData } from "@/services/dashboard-pie-events.config.js"
	

	export default{
		name 			 : 'Dashboard',
		components 		 : {
			GridLayout : VueGridLayout.GridLayout,
     		GridItem   : VueGridLayout.GridItem, 
     		// graphics,
     		cam,
			/*mapview*/
			events,
			cam_test,
			zone,
			blank_component,
			// timeline,
			detected_faces,
			recognized,
			counter,
			mapview,
			workspace,
			register_events_parking,
			statistics_parking,
			Iframe,
			alarm_stats_widget,
			DashboardPieEventsConfigDialog,
			dashboard_pie_events_widget,
			dashboard_kpi_events_widget,
			dashboard_alerts_by_device_heatmap_widget,
			dashboard_operator_action_time_widget,
			cloud_queue_widget,
			access_control_multi_face_roster,

		}, // compnenets
		props 	: ['id'],
		data 	: (vm) => ({
			
			list_components : { },
			components 		: [
					'events', 
					'zone',
					'timeline',
					/*
					'rfid', 
					'match_history', 
					'mapview', 
					'alerts'*/
			],
			list 					: [],
			dialog 					: false,
			info 					: '',
			// sidebar_grid 			: false,
			position_x 				: 0,
      		position_y				: 0,
			show_components 		: false,			
			list_dashboards_profile : [],
			dialog_option_comp 		: false,
			pieEventsDialog 			: false,
			pieEventsStagedConfig 	: null,
			chartPresetIntervalDialog: false,
			chartPresetPendingItem	: null,
			chartPresetInterval		: 'today',
			chartPresetIntervalOptions: [
				{ textKey: 'dashboard_pie_events_preset_today', value: 'today' },
				{ textKey: 'dashboard_pie_events_preset_yesterday', value: 'yesterday' },
				{ textKey: 'dashboard_pie_events_preset_week', value: 'week' },
				{ textKey: 'dashboard_pie_events_preset_15d', value: '15d' },
				{ textKey: 'dashboard_pie_events_preset_30d', value: '30d' },
			],
			isDashboardReady		: false, // Nueva propiedad para controlar el estado de carga
			hasDashboardPermissions	: false, // Nueva propiedad para verificar permisos
			option_setting 			: [
				{
					text : 'Select type VideoStream',
					key  : 'type_videostream',
					type : 'select',
					list : [
						'cam',
						'cam_test'
					]
				},
				{
					text : 'Init with streams',
					key  : 'init_streams',
					type : 'select',
					list : [
						'Yes',
						'No'
					]
				},
				{
					text : 'Init with Analytic',
					key  : 'type_analytic',
					type : 'select',
					list : [
						'motion',
						'event'
					]
				},
				{
					text : 'Type Stream',
					key  : 'type_stream',
					type : 'select',
					list : [
						'udp',
						'event'
					]
				},
			],
			setting_dashboard 	: {
				type_videostream 	: 'cam_test',
				init_streams 	 	: 'No',
				type_analytic 	 	: 'motion',
				type_stream 	 	: 'udp',
			},
			list_paginations 		: [0],	
			paginate 				: [],				
			idx_layout 				: 0,
			options_dashboards  	: [ // pending
				{
					key  : "dashboards",
					title : "dashboards",
					icon : "mdi-monitor-dashboard",
					action : "set_profile",

					sub_group : "profiles_default",
					sub_list  : "list_profiles",						
					sub_title : "",
				},
				{
					
					key  : "components",
					title : "components",
					icon : "mdi-drag",
					action : "set_profile",

					sub_group : "profiles_default",
					sub_list  : "list_profiles",						
					sub_title : "",
				}
			],
			list_profiles 			: [
				{
					name 			: 'LPR',
					key 			: 'lpr',	
					enable 			: false,
					components 		: [ 
						// 'counter', //  - Daily 
						// 'counter - Monthly',  
						{ key : "events", text : "events", from: "lpr", component : "events" },
						// { key : "alerts", text : "alerts", from: "lpr" },
						
						
					]				
				},
				{
					name 			: 'TECNOPARKING',
					key 			: 'parking',	
					enable 			: false,
					components 		: [ 
						// 'counter', //  - Daily 
						// 'counter - Monthly',  
						{ key : "register_events", text : "register_events", from: "parking", component : "register_events_parking" },
						{ key : "statistics", text : "statistics", from: "parking", component : "statistics_parking" },
						{ key : "events", text : "events", from: "parking", component : "events" },
						{ key : "grouped_events", text : "grouped_events", from: "counter", component : "events", ref: "counter" }
					]				
				},
				{
					name 		: 'FACE',
					key 		: 'face',
					id 			: 1, 
					enable 		: false,
					components 	: [
						/*{
							key 		: "events",
							name  		: vm.$ml.get("events"),
							component 	: "events",
							ref 	  	: "face",

						},*/
						{
							key 		: "recognized",
							text  		: "recognized",
							component 	: "events",
							ref 	  	: "face_recognized",
							subtitle 	: "recognized",
							from 		: "face",

						},
						{
							key 		: "detected",
							text  		: "detected",
							component 	: "events",
							ref 	  	: "face_detected",
							subtitle 	: "detected",
							from 		: "face",


						},
						{
							key 		: "multi_face_roster",
							text  		: "multi_face_roster",
							component 	: "access_control_multi_face_roster",
							from 		: "face",
						},
						{
							key 		: "access_terminal_events",
							text  		: "access_terminal_events",
							component 	: "events",
							ref 	  	: "control",
							subtitle 	: "access_terminal_events",
							from 		: "face",
						},

						
						// 'cam_test'
					]					
				},
				{
					name 		: 'MOTION',
					key 		: 'motion',
					id 			: 1,
					enable 		: false,
					components 	: [
						{ key : "events", text : "events", from: "motion", component : "events", },						
						{ key : "zone", text : "zone", from: "motion", component : "zone", },						
						// { key : "timeline", text : "timeline", from: "motion", component : "timeline", },						
						
						// '',
												
					]					
				},
				{
					name 		: 'OBJECTS',
					key 		: 'objects',
					id 			: 1,
					enable 		: false,
					components 	: [						
						{ key : "events", text : "events", from: "objects", component : "events", },						
						{ key : "zone", text : "zone", from: "objects", component : "zone", },						
						// { key : "timeline", text : "timeline", from: "objects", component : "timeline", },																		
					]					
				},
				{
					name 		: 'ACTIONS',
					key 		: 'actions',
					id 			: 1,
					enable 		: false,
					components 	: [
						{ key : "events", text : "events", from: "actions", component : "events", },													
					]					
				},
				/*{
					name 		: 'GUNS',
					key 		: 'gun',
					id 			: 1,
					enable 		: false,
					components 	: [
						'events',						
					]					
				},*/
				{
					name 	   : 'ALARMS',
					key 	   : 'alarms',
					id 		   : 1,
					enable 	   : false,
					components : [
						{ key : "alerts", text : "alerts", from: "alarms", component : "events", },												
					]					
				},
				{
					name 	   : 'GRÁFICAS',
					key 	   : 'charts',
					id 		   : 1,
					enable 	   : false,
					components : [
						{ key : "pie_events", text : "dashboard_pie_events_total_type_pie", from: "charts", component : "dashboard_pie_events_widget", },
						{ key : "total_alertas", text : "dashboard_pie_events_preset_total_alertas", from: "charts", component : "dashboard_kpi_events_widget", preset : "total_alertas" },
						{ key : "total_alertas_atendidas", text : "dashboard_pie_events_preset_total_alertas_atendidas", from: "charts", component : "dashboard_kpi_events_widget", preset : "total_alertas_atendidas" },
						{ key : "porcentaje_operacion_efectiva", text : "dashboard_pie_events_preset_porcentaje_operacion_efectiva", from: "charts", component : "dashboard_kpi_events_widget", preset : "porcentaje_operacion_efectiva" },
						{ key : "alertas_pendientes_por_atender", text : "dashboard_pie_events_preset_alertas_pendientes_por_atender", from: "charts", component : "dashboard_kpi_events_widget", preset : "alertas_pendientes_por_atender" },
						{ key : "alertas_clasificadas_positivas_falso_positivas", text : "dashboard_pie_events_preset_alertas_clasificadas_positivas_falso_positivas", from: "charts", component : "dashboard_pie_events_widget", preset : "alertas_clasificadas_positivas_falso_positivas" },
						{ key : "alertas_por_dispositivo", text : "dashboard_pie_events_preset_alertas_por_dispositivo", from: "charts", component : "dashboard_alerts_by_device_heatmap_widget", preset : "alertas_por_dispositivo" },
						{ key : "tiempo_accion_operador", text : "dashboard_pie_events_preset_tiempo_accion_operador", from: "charts", component : "dashboard_operator_action_time_widget", preset : "tiempo_accion_operador" },
					]
				},
				{
					name 	   : 'MORE COMPONENTS',
					key 	   : 'more_components',
					id 		   : 1,
					enable 	   : false,
					components : [
						{ key : "counter", text : "counter", from: "more_components", component : "counter", },
						{ key : "mapview", text : "mapview", from: "more_components", component : "mapview", },
						{ key : "technical", text : "technical", from: "technical", component : "events", },
						{ key : "smart_event", text : "smart_event", from: "smart_event", component : "events", },
						{ key : "avc", text : "avc", from: "avc", component : "events", },
						{ key : "mixta", text : "unified_access_feed", from: "mixta", component : "events", },
						{ key : "peripherals", text : "peripherals", from: "peripherals", component : "events", },
						{ key : "incidents", text : "incidents", from: "incidents", component : "events", },
						{ key : "audios", text : "audios", from: "audios", component : "events", },
						{ key : "Iframe", text : "Iframe", from: "more_components", component : "Iframe", },						
						// 'workspace'
					]					
				},
			],
			
			search_device 			: '',
			list_streamings 		: {
				actives    : [],
				inactives  : []
			},
			
		session 				: {
			dashboards 		: false,
			components 		: true,
			streamings 		: true,
			sub_list_dev 	: true,
			workspace 		: true,
			estadisticas 	: true,
		},
		list_alarms_data		: [],
		bus 					: {},		
		list_type_devs  		: ["IP_CAM"]	
	}), // data
		

		computed:{
			render_filter_devices(){
				if (this.search_device) {
					return this.renderDevices.filter( dev => { // list_filter = 
						return dev 
						&& (dev.name.toLowerCase().indexOf(this.search_device.toLowerCase()) > -1 
						|| dev.deviceId.toLowerCase().indexOf(this.search_device.toLowerCase()) > -1);							
					});
				}else{
					return this.renderDevices;
				}				
			}, // render filter devices

			renderDevices(){
				return this.$store.getters["Devices/list"];
			},
			renderSidebarGrid:{
				get(){
					return this.$store.getters["Dashboard/getSidebarGrid"];
				},
				set(value){
					this.$store.commit("Dashboard/setSidebarGrid", value);
				}
			},
			render_list_workspaces(){
				// console.log("work dashboard : ", this.$store.state.Workspaces.list_workspaces)
				return this.$store.state.Workspaces.list_workspaces;// []//this.$Workspaces.get_workspaces();

			}, // render list workspaces
		list_alarms() {
			if (!this.list_alarms_data || this.list_alarms_data.length === 0) return [];
			return this.list_alarms_data.filter(alarm => alarm && alarm.state);
		},

		currentDashboard(){
			// Si no tiene permisos, devolver dashboard vacío
			if (!this.hasDashboardPermissions) {
					//console.log('🚫 Sin permisos - devolviendo dashboard vacío');
					return {
						dashboard: [],
						options: {
							draggable: false,
							resizable: true,
							prevent_collision: false,
							vertical_compact: false,
						},
						alertMode: "snack",
						name: "",
						id: null
					};
				}
				
				const profile = this.$store.getters["Dashboard/getCurrentProfile"];
				//console.log('📊 Profile from store:', profile);
				
				// Asegurar que siempre devuelva un objeto válido
				if (!profile || !profile.dashboard) {
					//console.log('⚠️ Profile inválido o sin dashboard - devolviendo dashboard vacío');
					return {
						dashboard: [],
						options: {
							draggable: false,
							resizable: true,
							prevent_collision: false,
							vertical_compact: false,
						},
						alertMode: "snack",
						name: "",
						id: null
					};
				}
				
				/*console.log('✅ Dashboard válido encontrado:', {
					name: profile.name,
					id: profile.id,
					dashboardLength: profile.dashboard ? profile.dashboard.length : 0,
					options: profile.options
				});*/
				
				return profile;
			},

			localizedChartPresetIntervalOptions(){
				return this.chartPresetIntervalOptions.map(option => ({
					text: this.$ml.get(option.textKey),
					value: option.value,
				}));
			},

		}, // computed

		watch: {
			id: {
				handler(newId) {
					
					
					// Verificar permisos antes de cargar
					this.checkDashboardPermissions();
					
					// Si no tiene permisos, no cargar el dashboard
					if (!this.hasDashboardPermissions) {
						console.warn('❌ Usuario sin permisos para el dashboard - no cargando');
						this.isDashboardReady = true;
						return;
					}
					
					// Marcar como no listo durante la carga
					this.isDashboardReady = false;
					
					// Cargar el dashboard si hay ID
					if (newId) {
						//console.log('📂 Cargando dashboard con ID:', newId);
						// Limpiar el dashboard actual
						this.$store.commit("Dashboard/setProfile", []);
						
						this.$store.dispatch("Dashboard/loadLocalProfile", { id: newId }).then(() => {
							//console.log('✅ Dashboard cargado exitosamente');
							this.dialog = false;
							this.isDashboardReady = true;
						}).catch((error) => {
							console.warn("❌ Error loading dashboard with ID", newId, ":", error);
							this.initializeEmptyDashboard();
						});
					} else {
						//console.log('⚠️ No hay ID específico, cargando dashboard default...');
						this.loadDashboard();
					}
				},
				immediate: true
			},
			'currentDashboard.dashboard': {
				handler(newVal) {
					// Solo procesar si tiene permisos
					if (!this.hasDashboardPermissions) {
						return;
					}
					
					if (Array.isArray(newVal) && newVal.length > 0) {
						this.dialog = false;
					}
				},
				immediate: true,
				deep: true
			},
			'$ml.current': function() {
				// Vuelve a generar los headers con el idioma nuevo
				this.set_header(this.ref, false);
			},
		},

		beforeDestroy(){						
			this.$Helper.clear_bus(EventBus, this.bus, 'dashboard');
			// Limpiar timeout de seguridad si existe
			if (this.safetyTimeout) {
				clearTimeout(this.safetyTimeout);
			}
			// Clear alarms polling
			if (this._alarmsPollingInterval) {
				clearInterval(this._alarmsPollingInterval);
			}
		}, // beforeDestroy

		mounted(){			
			//let vm 			 		= this;
			//let temp_bus 			= '';
			//let loaded_devices 		= false;		
			this.$store.commit("Dashboard/setFunctionCheckData", this.checkDataProfile);

			// Start alarms polling for sidebar reactivity
			let _fastCount = 0;
			this._syncAlarmsData();
			const fastInterval = setInterval(() => {
				this._syncAlarmsData();
				_fastCount++;
				if (_fastCount >= 10) {
					clearInterval(fastInterval);
					this._alarmsPollingInterval = setInterval(() => {
						this._syncAlarmsData();
					}, 5000);
				}
			}, 500);
			
			// Inicializar como no listo
			this.isDashboardReady = false;
			this.hasDashboardPermissions = false;
			
			//console.log('🚀 Iniciando carga del dashboard...');
			//console.log('👤 Usuario actual:', this.$store.getters["auth/user"]);
			//console.log('📋 Permisos actuales:', this.$store.getters["auth/permissions"]);
			
			// Verificar si el usuario está autenticado
			const user = this.$store.getters["auth/user"];
			if (!user || !user.user) {
				console.warn('❌ Usuario no autenticado, redirigiendo al login');
				this.$router.push('/');
				return;
			}
			
			// Verificar si los permisos están cargados
			const permissions = this.$store.getters["auth/permissions"];
			if (!permissions || Object.keys(permissions).length === 0) {
				//console.log('🔄 Permisos no cargados, cargando...');
				this.$store.dispatch('auth/list_permissions').then(() => {
					//console.log('✅ Permisos cargados, verificando permisos del dashboard...');
					this.checkDashboardPermissions();
					this.loadDashboard();
					// El watcher del ID se encargará de cargar el dashboard
				}).catch((error) => {
					console.error('❌ Error cargando permisos:', error);
					this.checkDashboardPermissions();
					this.loadDashboard();
					// El watcher del ID se encargará de cargar el dashboard
				});
			} else {
				//console.log('✅ Permisos ya cargados, verificando permisos del dashboard...');
				this.checkDashboardPermissions();
				this.loadDashboard();
				// El watcher del ID se encargará de cargar el dashboard
			}
		},
		
		methods:{
			_syncAlarmsData() {
				const list = this.$SmartEvent ? this.$SmartEvent.getListSmartEvent() : null;
				if (list && list.length > 0) {
					this.list_alarms_data = [...list];
				}
			},

			/**
			 * Carga el dashboard después de verificar permisos
			 */
			loadDashboard() {
				// Si no tiene permisos, no cargar nada más
				if (!this.hasDashboardPermissions) {
					//console.warn('❌ Usuario sin permisos para el dashboard - deteniendo carga');
					this.isDashboardReady = true; // Marcar como listo para mostrar el mensaje de error
					
					// Limpiar cualquier dashboard existente
					this.$store.commit("Dashboard/setProfile", []);
					this.$store.commit("Dashboard/setCurrentProfile", {
						dashboard: [],
						options: {
							draggable: false,
							resizable: true,
							prevent_collision: false,
							vertical_compact: false,
						},
						alertMode: "snack",
						name: "",
						id: null
					});
					
					return; // Salir temprano
				}
				
				//console.log('✅ Usuario con permisos, cargando dashboard...');
				
				// Solo cargar el dashboard si tiene permisos
				if (this.id) {
					//console.log("🔄 Cargando dashboard específico con ID:", this.id);
					this.$store.dispatch("Dashboard/loadLocalProfile", { id: this.id }).then(() => {
						//console.log('✅ Dashboard cargado exitosamente');
						this.isDashboardReady = true;
					}).catch((error) => {
						console.warn("❌ Error loading dashboard, initializing empty dashboard:", error);
						this.initializeEmptyDashboard();
					});
				} else {
					//console.log("🔄 No hay ID específico, buscando dashboard default...");
					this.$store.dispatch("Dashboard/getList").then(() => {
						const dashboards = this.$store.getters["Dashboard/getList"];
						const defaultDashboard = dashboards.find(d => d.state === 'default');
						
						if (defaultDashboard) {
							//console.log("✅ Dashboard default encontrado:", defaultDashboard.name, "ID:", defaultDashboard.id);
							
							// Si estamos en /dashboard, redirigir al dashboard default
							if (this.$route.path === '/dashboard') {
								//console.log("🚀 Redirigiendo desde /dashboard a dashboard default");
								this.$router.replace({ name: 'dashboards', params: { id: defaultDashboard.id }})
									.then(() => {
										//console.log("✅ Redirección exitosa a dashboard default");
										// El dashboard se cargará automáticamente cuando cambie la ruta
									})
									.catch(error => {
										if (error.name !== 'NavigationDuplicated') {
											console.error("❌ ERROR en redirección:", error);
										}
									});
							} else {
								// Si ya estamos en la ruta correcta, simplemente cargar
								this.$store.dispatch("Dashboard/loadLocalProfile", { id: defaultDashboard.id }).then(() => {
									this.$nextTick(() => {
										//console.log('✅ Dashboard default cargado exitosamente');
										this.isDashboardReady = true;
									});
								}).catch((error) => {
									console.warn("❌ Error loading default dashboard:", error);
									this.initializeEmptyDashboard();
								});
							}
						} else {
							//console.log("⚠️ No hay dashboard default, inicializando dashboard vacío");
							this.initializeEmptyDashboard();
						}
					}).catch((error) => {
						console.error("❌ Error getting dashboard list:", error);
						this.initializeEmptyDashboard();
					});
				}
			},
			
			/**
			 * Verifica si el usuario tiene permisos para el dashboard
			 */
			checkDashboardPermissions() {
				try {
					// Verificar si el usuario está autenticado
					const user = this.$store.getters["auth/user"];
					if (!user || !user.user) {
						console.warn('❌ Usuario no autenticado');
						this.hasDashboardPermissions = false;
						return;
					}

					const roleId = user.user.roleId;
					/*console.log('🔐 Verificando permisos del dashboard para usuario:', {
						user: user.user,
						roleId: roleId,
						allPermissions: this.$store.getters["auth/permissions"]
					});*/

					// Si es admin (roleId = 1), dar acceso completo
					if (roleId === 1) {
						//console.log('👑 Usuario admin detectado - acceso completo al dashboard');
						this.hasDashboardPermissions = true;
						return;
					}

					// Para otros roles, verificar permisos específicos del dashboard
					const permissions = this.$store.getters["auth/permissions"];
					if (!permissions || Object.keys(permissions).length === 0) {
						//console.warn('⚠️ Permisos no cargados aún, esperando...');
						// Esperar un poco y volver a intentar
						setTimeout(() => {
							this.checkDashboardPermissions();
						}, 1000);
						return;
					}

					const dashboardView = this.$store.getters["auth/permission"]("dashboard", "can_view");
					const wildcardView = this.$store.getters["auth/permission"]("*", "can_view");
					
					/*	console.log('📋 Permisos específicos del dashboard:', {
						dashboardView,
						wildcardView
					});*/
					
					// Verificar si tiene permisos explícitos
					this.hasDashboardPermissions = (dashboardView === true || wildcardView === true);
					
					if (this.hasDashboardPermissions) {
						//console.log('✅ Usuario con permisos explícitos para el dashboard');
					} else {
						//console.warn('❌ Usuario sin permisos explícitos para el dashboard');
						//console.log('📋 Permisos disponibles:', this.$store.getters["auth/permissions"]);
					}
				} catch (error) {
					console.error("❌ Error verificando permisos del dashboard:", error);
					this.hasDashboardPermissions = false;
				}
			},
			
			/**
			 * Inicializa un dashboard vacío con configuración por defecto
			 */
			initializeEmptyDashboard() {
				// Solo inicializar si tiene permisos
				if (!this.hasDashboardPermissions) {
					this.isDashboardReady = true; // Marcar como listo para mostrar mensaje de error
					return;
				}
				
				// Create a test dashboard with a simple component
				/*const testDashboard = {
					dashboard: [
						{
							x: 0,
							y: 0,
							w: 6,
							h: 4,
							i: "test-component",
							Id: "test-component",
							component: "blank_component",
							ref: "test-component"
						}
					],
					options: {
						draggable: true,
						resizable: true,
						prevent_collision: false,
						vertical_compact: false,
					},
					alertMode: "snack",
					name: "Test Dashboard",
					id: "test"
				};*/
				
				//this.$store.commit("Dashboard/setCurrentProfile", testDashboard);
				this.isDashboardReady = true;
				//console.log('✅ Dashboard de prueba inicializado correctamente');
			},
			
			resizedEvent: function(i){
            	// const msg = "RESIZED i=" + i + ", X=" + newX + ", Y=" + newY + ", H(px)=" + newHPx + ", W(px)=" + newWPx;
            	let vn = this;
            	if (this.currentDashboard.dashboard && this.currentDashboard.dashboard.length > 0 && this.currentDashboard.dashboard[i] ) {            		//&& !this.layout[i].resize
	            	this.currentDashboard.dashboard[i].resize = !this.currentDashboard.dashboard[i].resize;	            	
            	}
				this.$store.commit("Dashboard/saveLocalProfile");
            	// console.log(msg);
        	},
		    movedEvent: function(){
				this.$store.commit("Dashboard/saveLocalProfile");				
            	// let msg = "MOVED i=" + i + ", X=" + newX + ", Y=" + newY;
	            // this.eventLog.push(msg);
        	},
			// moveEvent_side: function(i, newX, newY){
		    //     // console.log("MOVE sidebar i=" + i + ", X=" + newX + ", Y=" + newY);		    		    
		    // },
		    // moveEvent: function(i, newX, newY){
		    //     // console.log("MOVE i=" + i + ", X=" + newX + ", Y=" + newY);		        
		    // },
	        // layoutCreatedEvent: function(newLayout){
	        //     this.eventLog.push("Created layout");
	        //     console.log("Created layout: ", newLayout)
	        // },
	        // layoutBeforeMountEvent: function(newLayout){
	        //     this.eventLog.push("beforeMount layout");
	        //     console.log("beforeMount layout: ", newLayout)
	        // },
	        // layoutMountedEvent: function(newLayout){
	        //     this.eventLog.push("Mounted layout");
	        //     console.log("Mounted layout: ", newLayout)
	        // },
	        // layoutReadyEvent: function(newLayout){
	        //     this.eventLog.push("Ready layout");
	        //     console.log("Ready layout: ", newLayout)
	        // },
	        // layoutUpdatedEvent: function(newLayout){
	        //     this.eventLog.push("Updated layout");
	        //     console.log("Updated layout: ", newLayout)
	        // },

			add_component(item){ // index, info = null				
				if (item && item.from === 'charts' && item.preset) {
					this.openChartPresetIntervalDialog(item);
					return;
				}
				if (item && item.from === 'charts' && item.key === 'pie_events') {
					this.openPieEventsDialog();
					return;
				}
				this.add_draw({...item}); // component, null, info
			}, 
			openChartPresetIntervalDialog(item){
				this.chartPresetPendingItem = {...item};
				this.chartPresetInterval = 'today';
				this.chartPresetIntervalDialog = true;
			},
			closeChartPresetIntervalDialog(){
				this.chartPresetIntervalDialog = false;
				this.chartPresetPendingItem = null;
			},
			confirmChartPresetInterval(){
				const item = this.chartPresetPendingItem;
				const interval = this.chartPresetInterval || 'today';

				this.chartPresetIntervalDialog = false;
				this.chartPresetPendingItem = null;

				if (!item) return;
				if (item.preset === 'total_alertas') {
					this.addTotalAlertsKpiPreset(interval);
					return;
				}
				if (item.preset === 'total_alertas_atendidas') {
					this.addTotalAttendedAlertsKpiPreset(interval);
					return;
				}
				if (item.preset === 'porcentaje_operacion_efectiva') {
					this.addEffectiveOperationPercentageKpiPreset(interval);
					return;
				}
				if (item.preset === 'alertas_pendientes_por_atender') {
					this.addPendingAlertsKpiPreset(interval);
					return;
				}
				if (item.preset === 'alertas_clasificadas_positivas_falso_positivas') {
					this.addClassifiedAlertsChartPreset(interval);
					return;
				}
				if (item.preset === 'alertas_por_dispositivo') {
					this.addAlertsByDeviceHeatmapPreset(interval);
					return;
				}
				if (item.preset === 'tiempo_accion_operador') {
					this.addOperatorActionTimePreset(interval);
				}
			},
			addTotalAlertsKpiPreset(timePreset = 'today'){
				const titleKey = 'dashboard_pie_events_preset_total_alertas';
				const title = this.$ml.get(titleKey);
				const timezone = this.$timezone || 'America/Lima';
				const config = {
					name: title,
					title,
					titleKey,
					chartType: 'kpi',
					datasource: 'alarms',
					table: null,
					devices: [],
					time: {
						preset: timePreset,
						custom: {
							from: null,
							to: null,
							tz: timezone,
						},
					},
					groupBy: [],
					filters: [],
					refreshSeconds: 60,
					appearance: {
						color: '#1E88E5',
						icon: 'mdi-shield-check',
					},
				};

				this.add_draw({
					key: 'total_alertas',
					from: 'charts',
					component: 'dashboard_kpi_events_widget',
					stream_data: buildPieEventsStreamData(config, null),
					config,
				});
			},
			addTotalAttendedAlertsKpiPreset(timePreset = 'today'){
				const titleKey = 'dashboard_pie_events_preset_total_alertas_atendidas';
				const title = this.$ml.get(titleKey);
				const timezone = this.$timezone || 'America/Lima';
				const config = {
					name: title,
					title,
					titleKey,
					chartType: 'kpi',
					metric: 'attended_alerts',
					datasource: 'alarms',
					table: 'alarms',
					devices: [],
					time: {
						preset: timePreset,
						custom: {
							from: null,
							to: null,
							tz: timezone,
						},
					},
					groupBy: [],
					filters: [],
					refreshSeconds: 60,
					appearance: {
						color: '#43A047',
						icon: 'mdi-check-decagram',
					},
				};

				this.add_draw({
					key: 'total_alertas_atendidas',
					from: 'charts',
					component: 'dashboard_kpi_events_widget',
					stream_data: buildPieEventsStreamData(config, null),
					config,
				});
			},
			addEffectiveOperationPercentageKpiPreset(timePreset = 'today'){
				const titleKey = 'dashboard_pie_events_preset_porcentaje_operacion_efectiva';
				const title = this.$ml.get(titleKey);
				const timezone = this.$timezone || 'America/Lima';
				const config = {
					name: title,
					title,
					titleKey,
					chartType: 'kpi',
					metric: 'effective_operation_percentage',
					metricFormat: 'percentage',
					datasource: 'alarms',
					table: 'alarms',
					devices: [],
					time: {
						preset: timePreset,
						custom: {
							from: null,
							to: null,
							tz: timezone,
						},
					},
					groupBy: [],
					filters: [],
					refreshSeconds: 60,
					appearance: {
						color: '#00897B',
						icon: 'mdi-percent-circle-outline',
					},
				};

				this.add_draw({
					key: 'porcentaje_operacion_efectiva',
					from: 'charts',
					component: 'dashboard_kpi_events_widget',
					stream_data: buildPieEventsStreamData(config, null),
					config,
				});
			},
			addPendingAlertsKpiPreset(timePreset = 'today'){
				const titleKey = 'dashboard_pie_events_preset_alertas_pendientes_por_atender';
				const title = this.$ml.get(titleKey);
				const timezone = this.$timezone || 'America/Lima';
				const config = {
					name: title,
					title,
					titleKey,
					chartType: 'kpi',
					metric: 'pending_alerts',
					datasource: 'alarms',
					table: 'alarms',
					devices: [],
					time: {
						preset: timePreset,
						custom: {
							from: null,
							to: null,
							tz: timezone,
						},
					},
					groupBy: [],
					filters: [],
					refreshSeconds: 60,
					appearance: {
						color: '#FB8C00',
						icon: 'mdi-alert-circle-outline',
					},
				};

				this.add_draw({
					key: 'alertas_pendientes_por_atender',
					from: 'charts',
					component: 'dashboard_kpi_events_widget',
					stream_data: buildPieEventsStreamData(config, null),
					config,
				});
			},
			addClassifiedAlertsChartPreset(timePreset = 'today'){
				const titleKey = 'dashboard_pie_events_preset_alertas_clasificadas_positivas_falso_positivas';
				const title = this.$ml.get(titleKey);
				const timezone = this.$timezone || 'America/Lima';
				const config = {
					name: title,
					title,
					titleKey,
					chartType: 'doughnut',
					metric: 'classified_alerts',
					datasource: 'alarms',
					table: 'alarms',
					devices: [],
					time: {
						preset: timePreset,
						custom: {
							from: null,
							to: null,
							tz: timezone,
						},
					},
					groupBy: 'classification',
					filters: [],
					refreshSeconds: 60,
				};

				this.add_draw({
					key: 'alertas_clasificadas_positivas_falso_positivas',
					from: 'charts',
					component: 'dashboard_pie_events_widget',
					stream_data: buildPieEventsStreamData(config, null),
					config,
				});
			},
			addAlertsByDeviceHeatmapPreset(timePreset = 'today'){
				const titleKey = 'dashboard_pie_events_preset_alertas_por_dispositivo';
				const title = this.$ml.get(titleKey);
				const timezone = this.$timezone || 'America/Lima';
				const config = {
					name: title,
					title,
					titleKey,
					chartType: 'alerts_by_device_heatmap',
					metric: 'alerts_by_device',
					datasource: 'alarms',
					table: 'alarms',
					devices: [],
					time: {
						preset: timePreset,
						custom: {
							from: null,
							to: null,
							tz: timezone,
						},
					},
					groupBy: 'deviceId',
					filters: [],
					limit: 10,
					refreshSeconds: 60,
				};

				this.add_draw({
					key: 'alertas_por_dispositivo',
					from: 'charts',
					component: 'dashboard_alerts_by_device_heatmap_widget',
					stream_data: buildPieEventsStreamData(config, null),
					config,
				});
			},
			addOperatorActionTimePreset(timePreset = 'today'){
				const titleKey = 'dashboard_pie_events_preset_tiempo_accion_operador';
				const title = this.$ml.get(titleKey);
				const timezone = this.$timezone || 'America/Lima';
				const config = {
					name: title,
					title,
					titleKey,
					chartType: 'operator_action_time',
					metric: 'operator_action_time',
					datasource: 'alarms',
					table: 'alarms',
					devices: [],
					time: {
						preset: timePreset,
						custom: {
							from: null,
							to: null,
							tz: timezone,
						},
					},
					groupBy: [],
					filters: [],
					refreshSeconds: 60,
				};

				this.add_draw({
					key: 'tiempo_accion_operador',
					from: 'charts',
					component: 'dashboard_operator_action_time_widget',
					stream_data: buildPieEventsStreamData(config, null),
					config,
				});
			},
			openPieEventsDialog(){
				this.pieEventsDialog = true;
			},
			closePieEventsDialog(){
				this.pieEventsDialog = false;
			},
			stagePieEventsConfig(payload){
				this.pieEventsStagedConfig = payload;
				this.pieEventsDialog = false;
				this.add_draw(payload);
			},
		
			add_stream(item_stream, idx){ // type, type_analytic, 
				if (item_stream) {
					if (this.currentDashboard.dashboard.some(x=> x && x.stream_data && x.stream_data.host_id == item_stream.deviceId)) {
						this.$EventBus.$emit("notifications_modal",{ type: "warning", message : this.$ml.get("already_exist_component_dashboard")})
					}else{						
						const  {type_stream, type_analytic, type_videostream} = this.setting_dashboard;
						this.render_filter_devices[idx].active 		= true;				
						this.add_draw({
							component: "cam_test",
							from : "cam_test",
							item : item_stream, // info Streaming
							type : type_stream, 
							type_videostream, 
							type_analytic
						});
					}
				}
			},
			add_draw(component){// data, info_component, analytic = ''
				// console.log(" Add draw ******** \n component", component, "\n info ", data, " \n info_component ", info_component, "\n analytic", analytic);				
				let draw 			= []; 
				let layout_items	= this.currentDashboard.dashboard, 					
					stream_data 	= [],
					len 			= 0, 
					x 				= 0, 
					y 				= 0, 
					w 				= 20, 
					h 				= 10, 
					min_h 			= 10, 
					min_w	 		= 20,
					ref_comp 		= '',					
					tempComponent 	= component.component;
				
					
					//Component size defaults
					if (tempComponent == 'events' || tempComponent == 'alerts') {
						w 		= 45; // 49
						h 		= 17; // 26
						min_h 	= 15; // 26
						min_w 	= 49;
					}else if (tempComponent == 'counter') { //  || tempComponent == 'counter - Daily' || tempComponent == 'counter - Monthly'
						w 		= 22; // 12
						h 		= 8; // 5
						min_h 	= 5;// 26
						min_w 	= 15; // 7
					} else if (tempComponent == 'rfid') {
						w 		= 64;
						h 		= 19;
						min_h 	= 12;//19
						min_w 	= 64;
					}else if (tempComponent == 'match_history') {
						w 		= 94;
						h 		= 23;
						min_h 	= 10//23
						min_w 	= 94;
					}else if(tempComponent == 'mapview'){
						stream_data = { locations : this.renderDevices };
						w 		= 30;
						h 		= 15;
						min_h 	= 15;
						min_w 	= 10;
				}else if(tempComponent == 'plate_search') {
					w 		= 45;
					h 		= 5;
					min_h 	= 5;
					min_w 	= 40;
				} else if (tempComponent === 'alarm_stats_widget') {
					w = 120; h = 40; min_h = 25; min_w = 60;
				} else if (tempComponent === 'dashboard_kpi_events_widget') {
					w = 30; h = 9; min_h = 7; min_w = 24;
				} else if (tempComponent === 'dashboard_pie_events_widget') {
					w = 45; h = 18; min_h = 12; min_w = 30;
				} else if (tempComponent === 'dashboard_alerts_by_device_heatmap_widget') {
					w = 60; h = 24; min_h = 16; min_w = 40;
				} else if (tempComponent === 'dashboard_operator_action_time_widget') {
					w = 60; h = 20; min_h = 16; min_w = 40;
				} else if (tempComponent === 'cloud_queue_widget') {
					w = 34; h = 17; min_h = 13; min_w = 24;
				} else if (tempComponent === 'access_control_multi_face_roster') {
					w = 60; h = 22; min_h = 14; min_w = 35;
				}else{
					let gw = 120 / 4;
						let gh = (this.$vuetify.breakpoint.height * 0.02137);
						
						w = gw;
						h = gh;
						min_h = 4;//8;
						min_w = 7;//15;						
					}
					
				if (tempComponent == 'workspace') {
					stream_data = component.item;
				}

				if (tempComponent === 'alarm_stats_widget') {
					// Full-width widget: place at x=0, below all existing items
					x = 0;
					const items = this.currentDashboard.dashboard || [];
					y = items.length > 0
						? Math.max(...items.map(item => (item.y || 0) + (item.h || 0)))
						: 0;
					this.$store.commit("Dashboard/setPositionX", 0);
					this.$store.commit("Dashboard/setPositionY", y + h);
				}

				if (component.from == "parking" && tempComponent != "events") {
						ref_comp += "_" + component.from;
					}
					if (["recognized", "detected", "access_terminal_events"].includes(component.key)) { // info_
						stream_data = { ...component };
						ref_comp 	= stream_data.ref;
					}
					// Components streams
					/*	if (tempComponent == 'cam') {
						if (from == 'udp' || from == 'event') {				
							stream_data = {
								host 	 : this.$localhost + ':4550/',
								host_id  : data.deviceId,
								hostname : data.name,
								name 	 : "dashboard" + data.deviceId, // analytic ?   : "dashboard",
								type 	 : from,
								info_cam : data, 
								name_analytic : analytic,
								// ip: data.ip
							};
						}*/
				if (tempComponent == 'cam_test') {
					stream_data = {							
						host_id  : component?.item?.deviceId, // data.
						hostname : component?.item?.name,
						info_cam : component?.item,
						channel  : 'hls',
					}
				}
				if (component.from === 'alarm_stats') {
					stream_data = component.item;
				}
				if (tempComponent === 'cloud_queue_widget') {
					stream_data = component.item || {};
				}
				if (tempComponent === 'dashboard_pie_events_widget' || tempComponent === 'dashboard_kpi_events_widget' || tempComponent === 'dashboard_alerts_by_device_heatmap_widget' || tempComponent === 'dashboard_operator_action_time_widget') {
					stream_data = component.stream_data || null;
				}
				if (tempComponent === 'access_control_multi_face_roster') {
					stream_data = component.stream_data || component.config || {};
				}
				if (tempComponent === 'alarm_stats_widget') {
					// positioning already handled above — skip generic logic
				} else if (tempComponent == 'cam_test' || tempComponent == 'cam' || tempComponent == 'blank_component') {

					x = this.$store.getters["Dashboard/getPositionX"];
					y = this.$store.getters["Dashboard/getPositionY"];
					if (x <= 120) {							
						this.$store.commit("Dashboard/setPositionX",  x + w);
					}
					
					if (x >= 120) {
						x = 0;
						y = h + this.$store.getters["Dashboard/getPositionY"]; //layout_items[len_dash-1].
						this.$store.commit("Dashboard/setPositionY",  y);
						this.$store.commit("Dashboard/setPositionX",  x + w);							
					}

				}else{
					x = this.$store.getters["Dashboard/getPositionX"];
					y = this.$store.getters["Dashboard/getPositionY"];
					let temp_w = x + w,
						temp_h = y;
					
					if (x + w >= 110) { // 80
						x 	= 0;
						y 	+= h;
						temp_w = 0;
						temp_h = y;						
					}					
					this.$store.commit("Dashboard/setPositionX", temp_w);
					this.$store.commit("Dashboard/setPositionY", temp_h);
				}
					len=this.currentDashboard.dashboard.length+1;
					
					draw = {
						x 			: x,
						y 			: y,
						w 			: w,
						h 			: h,
						i 			: len + tempComponent + new Date().getTime(),
						minW 		: min_w,
	          			minH 		: min_h,
						Id 			: len + tempComponent + new Date().getTime(),
						state 		: true,
						resize 		: false,
						ref 		: ref_comp || component.from,
						component  : tempComponent,
						stream_data,
					}
					
					this.$store.commit("Dashboard/addItemToCurrentProfile", draw);			
					this.$store.commit("Dashboard/saveLocalProfile");

			}, // add_draw

			del_draw(val){
				const idx = this.currentDashboard.dashboard.findIndex(x=> x.Id == val); 
				const item = idx>=0 ? this.currentDashboard.dashboard[idx]:null
				this.$store.commit("Dashboard/deleteElementCurrentProfile", idx);				
				if (this.currentDashboard.dashboard === 0) {
					this.$store.commit("Dashboard/setPositionX", 0);
					this.$store.commit("Dashboard/setPositionY", 0);					
				}else{
					this.$store.commit("Dashboard/checkPositions");
				}
				if (item && item.component == "cam_test" ) {
					this.render_filter_devices.some((x,idx)=> {
						if (x.deviceId == item.stream_data.host_id){
							this.render_filter_devices[idx].active=false;
							return true;							
						}
					})	
				
				}
				// this.layout 	= layout_temp;
				// this.component 	= list_component;
				// this.update_changed_layout();
				this.$store.commit("Dashboard/saveLocalProfile");
			}, // del
			
			actions(act, item){
				let vm = this;
				if (act == 'setting') {
					this.dialog_option_comp = true;
				}
				if (act == 'type_videostream') {
					//console.log('changed ', act);
				}
				if (act == 'set_profile') {
					
					
					this.$store.commit("Dashboard/setPositionX", 0);
					this.$store.commit("Dashboard/setPositionY", 0);					

					if (this.currentDashboard.dashboard && this.currentDashboard.dashboard.length > 0) {
						this.$store.commit("Dashboard/setProfile",[]);
					}
					if (item && item.length > 0) {						
						item.components.forEach( function(arr_profile, idx_profile){
							if (item.key == 'lpr' && (arr_profile == 'counter - Daily' || arr_profile == 'counter - Monthly')) {

								if (arr_profile == 'counter - Daily') {
									vm.add_draw(arr_profile, null, 'daily');
								}else{
									vm.add_draw(arr_profile, null, 'monthly');
								}
							}else{
								vm.add_draw(arr_profile, null, item.key);
							}
						})
					}

				}
			}, // action btn

			actions_received(action){
				// console.log("actions received : ", action);
				let { act , item, opt , ID } = action;
				if (act == 'resize_compt') {
					let vm 	= this;
					let idx = vm.currentDashboard.dashboard.findIndex( x => (x && x.Id == ID));
					if (idx >= 0) {						
						const { width , height } = item;
						vm.currentDashboard.dashboard[idx].w = width;
						vm.currentDashboard.dashboard[idx].h = height;

					}else{
						//console.log("No found Component", ID);
					}

				}
			}, // actions_received

			update_component(item){
				if (item) {
					let vm = this;
					const { key , component, value, ID } = item;
					if (vm.currentDashboard.dashboard && vm.currentDashboard.dashboard.length) {						
						const find = vm.currentDashboard.dashboard.some(comp => {
							if (comp && comp.Id == ID && (comp.stream_data || !comp.stream_data)  &&  comp.component == component ) {							
								if (comp.stream_data) {
									if (key) {
										comp.stream_data[key] = value;
									}else{
										comp.stream_data = value;
									}
								}else{
									comp.stream_data = value;
								}
								return true;
							}
						});
						// console.log("update component ", find, item);
						if (find) {
							// this.update_changed_layout();
							this.$store.commit("Dashboard/saveLocalProfile");
						}
					}
				}
			}, //

			check_selects(v){ // check components in layout
				// console.log(sel, 'init check', v.length, v)
				let list = v;
				let sel  = this.components;//list_components;
				for(let i in list){
					for(let j in sel){
						if (list[i].component == sel[j]) {	
							if (list[i].component !== 'alerts' && list[i].component !== 'zone') {								
								sel.splice(j, 1); // delete of components
							}
						}
					}
				}
				this.components = sel;
			}, // check selects
			checkDataProfile(){
				if (this.currentDashboard.dashboard && this.currentDashboard.dashboard.length) {
					// console.log("CHECK DATA ")
					this.check_data(this.currentDashboard.dashboard, this.render_filter_devices, "list_device")
				}
			},
	        check_data(layouts, list, type){ // update components if exist new changes
				let p_x  = 0, 
					p_y  = 0, 
					p_x1 = 0, 
					p_y1 = 0;

				if (layouts && layouts.length > 0) {
					let sw  = [];					
					for (let i = 0; i < layouts.length; i++) {						
						if ((['cam', 'cam_test'].includes(layouts[i].component)) && layouts[i].stream_data) {
							if (list && list.length) {
								let j = list.findIndex(x => (x && x.deviceId == layouts[i].stream_data.host_id));  /*&& layouts[i].stream_data.type == type*/
								if( j >= 0 ) {									
									let host_name = '';
									if (list[j].host) {
										host_name = list[j].host.name
									}else{
										host_name = list[j].name;
									}
									if (this.render_filter_devices && this.render_filter_devices.length > 0 && layouts[i] && layouts[i].stream_data && type == 'list_device') {
										this.render_filter_devices[j].active = true;
									
									}
									if (host_name !== layouts[i].stream_data.hostname ){  
										layouts[i].stream_data.hostname = host_name;
									}// if name								
								} // check stream data
								else{	
									sw.push(layouts[i].Id);
								}
							}// for check host device
							
							
						}// check component					
						if (layouts[i] && layouts[i].x > p_x) {
							p_x1 = layouts[i].x + layouts[i].w;
							p_x  = layouts[i].x;
						}
						if (layouts[i] && layouts[i].y > p_y) {
							p_y1 = layouts[i].y;
							p_y  = layouts[i].y;						
						}	
					} // for list					
					this.$store.commit("Dashboard/setPositionX", p_x1)
					this.$store.commit("Dashboard/setPositionY", p_y1)					
				
					if (sw && sw.length > 0) {					
						this.$store.commit("Dashboard/setProfile", this.currentDashboard.dashboard.filter( lay =>{
							return !sw.includes(lay.Id);
						}));	
					}
				}else{
					//console.log("No found length for check data")
				}
			},


			check_modules(){ // check modules actives
				let list 			= this.list_analytics;
				let list_component 	= this.list_profiles;
				let result 			= null;
				let vm 				= this;
				result = this.$Helper.searcherAll(list, true, 'active')
				if (result && result.obj) {
					list_component.forEach( function(arr_mod, idx_mod){
						let result1 = [];
						result1 = vm.$Helper.searcher(result.obj, arr_mod.key, 'key');
						if (result1) {
							vm.list_profiles[idx_mod].enable = true;
							//console.log('active component', vm.list_profiles[idx_mod].key)
						}
					})
				}
			}, // check modules


			
			render_devices(){					
				// let list_analytic 	= analytic_list;
				let devices 		= this.renderDevices;
				// console.log("Devices ************** dashboard : ", devices/*, this.$Format*/);
				if (devices && devices.length > 0) {
					
					this.list = [...devices];					
					this.check_data(this.currentDashboard.dashboard, [...devices], 'list_device');
					// console.log("check list ", this.list);
				}else
 				if (localStorage.getItem('list_devices')) {
					const list_temp 		= JSON.parse(localStorage.getItem('list_devices'));
					let vm  				= this;
					let check 				= true;
					vm.list 				= list_temp;					

					if (!this.list_paginations) {
						check = false;
					}
					if (vm.list && vm.list.length > 0) {
						this.check_data(this.currentDashboard.dashboard, list_temp, 'list_device');
					}
					

				} // devices get
				// this.$emit('status_steps', this.$ml.get('loaded_devices_list'));
				
			}, // render devices

    		change_stream_type(item_change, type){
    			//console.log(item_change, 'info to renders',item_change.Id)
    			let ID 			= item_change.Id;
    			let layout_temp = this.currentDashboard.dashboard;
    			for (let num in layout_temp){
					if (layout_temp[num].Id === ID) {
						if (layout_temp[num].stream_data) {
							//console.log("layout_temp[num].stream_data", layout_temp[num].stream_data);
							if (type == 'stream') {
								layout_temp[num].stream_data.type=item_change.new_val; // type stream
							}else{
								layout_temp[num].stream_data.name_analytic=item_change.new_val; // type analytic
							}
						}
						// console.log(layout_temp[num].stream_data.type, 'layout to renders')
					}
				}// for
				// this.layout = layout_temp;
				// this.update_changed_layout();
				this.$store.commit("Dashboard/saveLocalProfile");

    		}, // change stream type

	        /*save_local(opt){
	        	if (opt == 'setting_dashboard') {
	        		const to_local = JSON.stringify(this.setting_dashboard);
	        		localStorage.setItem(opt, to_local);
	        		this.dialog_option_comp = false;
	        	}	        	
	        	EventBus.$emit('notifications_modal', { 
	        		type 	: 'saved',
	        		message : opt
	        	});

	        }, // save local*/
	        
	        render_layout_data(item){	     // for valid   	
	        	let list_temp 	= this.currentDashboard.dashboard,
	        		search 		= item.layout_id,
	        		rl 			= this;

	        	const find = list_temp.some((arr_lay, idx_lay)=>{
	        		if (arr_lay.Id == search) {
	        			rl.layout[idx_lay].stream_data = item.info;
	        			return true;

	        		}
	        	})

	        	// console.log(find, this.layout, 'render layout data');
	        	// this.update_changed_layout();
	        	this.$store.commit("Dashboard/saveLocalProfile");

	        }, // render layout data
		}, // methods
	};
